import CurrencyComponent from './currency.component';
import CurrencyCreate from './create'
import CurrencyEdit from './edit'
import CurrencyAll from './all'

let currencyModule = angular.module('currency', [
  CurrencyCreate,
  CurrencyEdit,
  CurrencyAll
  ])

  .component('currency', CurrencyComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('currency.edit', {
        url: '/edit/:id',
        component: 'currencyedit',
        data: {
          requireACL: 'tnt_control_currency.edit'
        }
      })

      .state('currency.create', {
        url: '/create',
        component: 'currencycreate',
        data: {
          requireACL: 'tnt_control_currency.create'
        }
      })

      .state('currency.all', {
        url: '/all/:page',
        component: 'currencyall',
        data: {
          requireACL: 'tnt_control_currency.view'
        }        
      });

    // Default route for currency module
    $urlRouterProvider.when('/currency', '/currency/all/1');
  })

  .name;

export default currencyModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/index.js